// Module
var code = "<div class=\"task-item\" v-if=\"task\"> <span class=\"progress\" :style=\"{ width: progress }\"></span> <span v-if=\"showName\" class=\"text\">{{ resolvedName }}</span> <span v-if=\"task != null\" class=\"text\"> <slot name=\"progress-text\" :completed=\"task.task.CompletedActions\" :total=\"task.task.TotalActions\"></slot> </span> </div> ";
// Exports
export default code;